/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getById } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Form, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";

interface ITesisShort {
  id: string;
  tituloDoctor: string;
}

export const ResearchTesis: FC = () => {
  const history = useHistory();

  let { staffId, isAdmin } = useSelector(({ user }: IStore) => user as IUser);

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { TESIS, INVESTIGATORS } = paths;
  const [tesis, setTesis] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredTesis, setFilteredTesis] = useState<ITesisShort[]>([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    try {
      isMountedRef.current && loadTesis();
    } catch (error) {
      console.log(error);
      console.log("HTTP call cancelled");
    }
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadTesis = async () => {
    try {
      if (isAdmin) {
        const response = await getAll(TESIS, source);
        if (isMountedRef.current) {
          filterTesis(response);
        }
      } else if (!isAdmin) {
        let id = staffId.toString();
        const investigator = await getById(INVESTIGATORS, id, source);
        if (isMountedRef.current) {
          filterTesisByInvestigator(investigator);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterTesis = (rawTesis: any[]) => {
    let tesis: ITesisShort[] = rawTesis.map(
      ({ id, tituloDoctor }: ITesisShort) => ({
        id,
        tituloDoctor,
      })
    );
    setTesis(tesis);
    setFilteredTesis(tesis);
  };

  const filterTesisByInvestigator = (rawTesis: any) => {
    // console.log(rawGroups.investigationGroup);
    if (!!rawTesis.investigationTesis) {
      let tesis: ITesisShort[] = [
        {
          id: rawTesis?.investigationTesis?.id,
          tituloDoctor: rawTesis?.investigationTesis?.tituloDoctor,
        },
      ];
      setTesis(tesis);
      setFilteredTesis(tesis);
    }
  };

  const handleSearch = (value: any) => {
    setSearch(value);
    setFilteredTesis(
      tesis.filter(({ tituloDoctor }: any) =>
        tituloDoctor.toLowerCase().includes(value.toLowerCase())
      )
    );
    !value && setFilteredTesis(tesis);
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12 d-flex justify-content-between">
          <h3>Tesis</h3>
          <div>
            {isAdmin && (
              <button
                className="baseBtn"
                onClick={() => history.push(`${ROUTES.Tesis.create}`)}
              >
                + Añadir
              </button>
            )}
          </div>
        </div>
      </div>
      {/* <div className="center flex-column justify-content-around text-center p-5 mt-2"> */}
      <div className="row mt-4">
        <Form.Group as={Col}>
          <InputGroup className="shadow">
            <InputGroup.Prepend>
              <InputGroup.Text className="inputGroup ">
                <FontAwesomeIcon color="#0073B5" icon={faSearch} />
              </InputGroup.Text>
            </InputGroup.Prepend>
            <Form.Control
              type="text"
              placeholder="Buscar..."
              className="form-control"
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </div>
      <div className="row">
        <div className="col-12 ">
          <table className="table table-hover">
            <tbody>
              {filteredTesis?.map(
                ({ id, tituloDoctor }: ITesisShort, index: number) => (
                  <tr
                    key={index}
                    className="pointer"
                    onClick={() => history.push(`${ROUTES.Tesis.all}/${id}`)}
                  >
                    <td>{`${tituloDoctor}`}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
          {isLoading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border mt-5" role="status" />
            </div>
          )}

          {!filteredTesis.length && !isLoading && isAdmin && (
            <div className="d-flex justify-content-center mb-3">
              <h5>-No existen tesis-</h5>
            </div>
          )}

          {!filteredTesis.length && !isLoading && !isAdmin && (
            <div className="d-flex justify-content-center mb-3">
              <h5>-No pertenece a ningúna tesis-</h5>
            </div>
          )}
        </div>
      </div>
    </div>
    // </div>
  );
};
